module.exports = __webpack_public_path__ + "static/media/doortodoor.1a568ddb.png";